














import { Component, Prop, Vue } from 'vue-property-decorator';
import { Command } from '../../cablin/commands';

@Component({
  components: {
    CommandIfComp: () => import('./CommandIf.vue'),
    CommandWhileComp: () => import('./CommandWhile.vue'),
    CommandListComp: () => import('./CommandList.vue'),
    CommandAssignComp: () => import('./CommandAssign.vue'),
    CommandCallComp: () => import('./CommandCall.vue'),
    CommandReturnComp: () => import('./CommandReturn.vue'),
    CommandContinueComp: () => import('./CommandContinue.vue'),
    CommandBreakComp: () => import('./CommandBreak.vue'),
    CommandVarComp: () => import('./CommandVar.vue'),
  },
})
export default class CommandComp extends Vue {
  @Prop() private cmd!: Command
  cmdType (): string {
    return this.cmd.cmdName()
  }
}
